



































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

interface Member {
  name: string;
  age: string;
  kana: string;
  sex: string;
  tel?: string;
  email?: string;
  menu: string;
  rank: string;
  experiance: string;
  blank: string;
  rental: string;
  rentalItem: string[];
  height: string;
  weight: string;
  footSize: string;
  sight: string;
  rentalDisabled: boolean;
  rentalItemDisabled: boolean;
}

interface MyObj {
  dates: string[];
  hotel: string;
  transfer: string;
  members: Member[];
  remarks: string;
  confirm: string;
  whaleConfirm: string;
  _token: string;
}

interface SelectItem {
  title: string;
  value: string;
}

const member: Member = {
  name: "",
  kana: "",
  age: "",
  sex: "",
  tel: "",
  email: "",
  menu: "",
  rank: "",
  experiance: "",
  blank: "",
  rental: "",
  rentalItem: [],
  height: "",
  weight: "",
  footSize: "",
  sight: "",
  rentalDisabled: false,
  rentalItemDisabled: false,
};

@Component
export default class Home extends Vue {
  get refs(): any {
    return this.$refs;
  }

  overlay = false;
  dialog = false;
  dialogWhale = false;

  valid = true;
  required: any = [(v: any) => !!v || "入力してください"];
  multipieRequired: any = [(v: []) => v.length > 0 || "選択してください"];
  whaleChecked: any = [(v: []) => !!v || "選択してください"];

  form: MyObj = {
    dates: [],
    hotel: "",
    transfer: "送迎なし",
    members: [{ ...member }],
    remarks: "",
    confirm: "",
    whaleConfirm: "",
    _token: "",
  };

  sex = ["男性", "女性"];
  ranks = ["なし", "OWD", "AOW", "RED", "DM以上", "その他"];

  experiances = [
    "初めて",
    "20本以下",
    "20～50本",
    "50～100本",
    "100～150本",
    "150本以上",
  ];
  blanks = [
    "初めて",
    "3か月以内",
    "3～6か月",
    "6～12か月",
    "1年～2年",
    "3年以上",
  ];

  menus = [
    { title: "ケラマファンダイビング（16,500円）", value: "fundiving" },
    { title: "ドリフトダイビング（25,000円）", value: "driftdiving" },
    { title: "ケラマ体験ダイビングAコース（19,800円）", value: "kerama_a" },
    { title: "ケラマ体験ダイビングBコース（22,000円）", value: "kerama_b" },
    { title: "ホエールスイム（25,000円）", value: "whale" },
    { title: "その他（備考にご要望をご入力ください）", value: "other" },
    {
      title: "ライセンス講習（備考欄にご希望メニューをご入力ください）",
      value: "license",
    },
  ];

  // rentalTypesをcomputedに変更 menusがdriftdivingの場合は、フルレンタルのあとに重器材セットと軽器材セットを追加
  get rentalTypes(): SelectItem[] {
    const rentalTypes = [
      { title: "不要", value: "none" },
      { title: "フルレンタル", value: "full" },
    ];
    // if (this.menus.find((menu) => menu.value === "driftdiving")) {
    //   rentalTypes.push({ title: "重器材セット", value: "heavy" });
    //   rentalTypes.push({ title: "軽器材セット", value: "light" });
    // }
    rentalTypes.push({ title: "個別レンタル", value: "individual" });
    return rentalTypes;
  }

  // driftdivingの場合は、末尾にフロート500円、DC1,650円を追加
  get rentalItems(): SelectItem[] {
    const rentalItems = [
      { title: "BCD（1,650円）", value: "bcd" },
      { title: "レギュレーター（1,650円）", value: "regulator" },
      { title: "ウェットスーツ（1,650円）", value: "wetsuit" },
      { title: "マスク※度付きあり（1,100円）", value: "mask" },
      { title: "フィン、ブーツ（1,100円）", value: "fin" },
    ];

    // driftdivingかつフルレンタル以外の場合は、フロート500円、DC1,650円を追加
    if (
      this.menus.find((menu) => menu.value === "driftdiving") &&
      this.form.members.some((member) => member.rental !== "full")
    ) {
      rentalItems.push({ title: "フロート（500円）", value: "float" });
      rentalItems.push({ title: "DC（1,650円）", value: "dc" });
    }
    return rentalItems;
  }

  setValues(member: Member) {
    switch (member.menu) {
      case "kerama_a":
      case "kerama_b":
        member.rental = "full";
        member.rentalDisabled = true;
        member.rentalItem = this.rentalItems.map((elm: SelectItem) => {
          return elm.value;
        });
        member.rentalItemDisabled = true;
        break;

      default:
        member.rental = "";
        member.rentalItem = [];
        member.rentalDisabled = false;
        member.rentalItemDisabled = false;
        break;
    }
    return member;
  }

  getRentalTypes(menu: string): SelectItem[] {
    switch (menu) {
      case "whale":
        return this.rentalTypes.map((elm: SelectItem) => {
          if (elm.value === "full") {
            return {
              title: elm.title + "（3,850円）",
              value: elm.value,
            };
          }
          return elm;
        });

      case "kerama_a":
      case "kerama_b":
        return this.rentalTypes;

      default:
        return this.rentalTypes.map((elm: SelectItem) => {
          if (elm.value === "full") {
            return {
              title: elm.title + "（6,000円）",
              value: elm.value,
            };
          }
          return elm;
        });
    }
  }

  getRentalItems(rentalType: string): SelectItem[] {
    if (rentalType === "full") {
      return this.rentalItems.map((elm: SelectItem) => {
        return { title: elm.title.replace(/（.*円）/, ""), value: elm.value };
      });
    }

    return this.rentalItems;
  }

  setRentalItems(member: Member) {
    if (member.rental === "full") {
      member.rentalItemDisabled = true;
      member.rentalItem = this.rentalItems.map((elm: SelectItem) => {
        return elm.value;
      });

      if (member.menu === "whale") {
        member.rentalItem = member.rentalItem.filter((item) =>
          ["wetsuit", "mask", "fin"].includes(item)
        );
      }
    } else {
      member.rentalItemDisabled = false;
      member.rentalItem = [];
    }
  }

  appendMember() {
    this.form.members.push({ ...member });
  }

  deleteMember(index: number) {
    this.form.members.splice(index, 1);
  }

  get choiceWhale(): boolean {
    const result = this.form.members.filter(
      (member) => member.menu === "whale"
    );
    return result.length > 0;
  }

  getDateMin() {
    const today = new Date();
    return today.toISOString();
  }

  async validate() {
    this.refs.form.validate();
  }

  // membersのvalueをタイトルに変換。変換する順番に注意
  formatMembers() {
    const members: Member[] = JSON.parse(JSON.stringify(this.form.members));
    const newFormMembers = members.map((member) => {
      member.rentalItem = member.rentalItem.map((item) => {
        return (
          this.getRentalItems(member.rental).find(
            (rental) => rental.value === item
          )?.title || "None Item"
        );
      });

      member.rental =
        this.getRentalTypes(member.menu).find(
          (rental) => rental.value === member.rental
        )?.title || "None Value";

      member.menu =
        this.menus.find((menu) => menu.value === member.menu)?.title ||
        "None Menu";

      return member;
    });
    return newFormMembers;
  }

  async dispatch() {
    if (this.refs.form.validate()) {
      this.overlay = true;

      this.form.members = this.formatMembers();

      await this.axios.get("/system/csrf").then((response) => {
        this.form._token = response.data;
      });

      await this.axios
        .post("/system/sent", this.form)
        .then(() => {
          this.$router.push("complete#app");
        })
        .catch((e) => {
          console.log(e);
        });
      this.overlay = false;
    }
  }
}
